import { action } from 'satcheljs';
import { ClientItemId } from 'owa-client-ids';

export default action('onNotifyOrganizerToggled', (id: ClientItemId, sendResponse: boolean) => ({
    id,
    sendResponse,
}));
